import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Button from 'ui/elements/buttons/Button';
import { CreateCommunityCompanyNoteDTO } from 'types/company/communityNotes';
import FormikTextField from 'ui/elements/form/formik/FormikTextField';

interface Props {
  onSubmit: (data: CreateCommunityCompanyNoteDTO) => Promise<void>;
  onCancel: () => void;
  isSaving: boolean;
}

const noteSchema = Yup.object().shape({
  title: Yup.string().required('Title is required').max(500, 'Title cannot be longer than 500 characters'),
  description: Yup.string(),
});

export default function CreateNoteForm({ onSubmit, onCancel, isSaving }: Props) {
  const formik = useFormik({
    initialValues: {
      title: '',
      description: '',
    },
    onSubmit: async values => {
      await onSubmit(values);
      formik.resetForm();
    },
    validationSchema: noteSchema,
    enableReinitialize: false,
  });

  return (
    <div className="u-content-spacing-bottom">
      <FormikTextField formikProps={formik} name="title" label="Title" autoFocus required />
      <FormikTextField
        formikProps={formik}
        name="description"
        label="Note"
        multiline
        minRows={3}
        maxRows={8}
        required
      />
      <div className="u-flex u-flex--gap-half">
        <Button onClick={() => formik.handleSubmit()} kind="primary" isLoading={isSaving} disabled={isSaving}>
          Add note
        </Button>
        <Button onClick={onCancel} kind="tertiary" disabled={isSaving}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
